module.exports = __webpack_public_path__ + "img/yitihua.771f1f2c.png";